<script>
  export let flagship_sheets_list;
  let product_index;
</script>

<div class="theme_content">
  <div class="theme_content_item">
    {#each flagship_sheets_list as flagship_product, i}
      <div class="item_box item_box_{i}">
        <div class="box_inside">
          <div class="box_top">
            <div class="content_video">
              {#if flagship_product.video_link}
                <iframe
                  title
                  width="100%"
                  height="100%"
                  frameborder="0"
                  scrolling="yes"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope;
                    picture-in-picture"
                  allowfullscreen
                  src={flagship_product.video_link} />
              {:else}<img src={flagship_product.photo_link} alt="" />{/if}
            </div>
            <div class="content_desc">
              <h4>{flagship_product.introduction_title}</h4>
              {#each flagship_product.content_after_split as content}
                <p>{content}</p>
              {/each}
            </div>
          </div>
          <slot product_index={i} />
        </div>
      </div>
    {/each}
  </div>
</div>
